import { API_BASE_URL } from "@constants/urls";
import axios from "axios";
import { commerceBasePath } from "./constants";
import type { ExternalAuthResponse } from "./types";

export const handleExternalAuth = async ({
	token,
	platform,
	tenantId,
}: {
	token: string;
	platform?: string;
	tenantId?: string;
}): Promise<ExternalAuthResponse> => {
	const { data } = await axios.post(
		`${API_BASE_URL}/${commerceBasePath}/auth/external`,
		{
			token,
			platform,
			provider: "clerk",
			tenantId,
		},
	);
	return data;
};
